import { createContext } from "react";
import type { BillingContextValue } from "../../cache";

export const BillingContext = createContext<BillingContextValue | null>(null);
